import { render, staticRenderFns } from "./OrderShow.vue?vue&type=template&id=90320276&scoped=true"
import script from "./OrderShow.vue?vue&type=script&lang=ts"
export * from "./OrderShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90320276",
  null
  
)

export default component.exports